import React from 'react';
import { Button, ConfigProvider } from 'antd';
import { DisconnectOutlined } from '@ant-design/icons';
import ru_RU from 'antd/locale/ru_RU';
import './offline-screen.css';

const OfflineScreen = () => (
    <ConfigProvider locale={ru_RU}>
        <div className="offline-screen" role="alert">
            <DisconnectOutlined className="offline-screen__icon" aria-hidden />
            <h1 className="offline-screen__title">Отсутствует подключение к сети</h1>
            <p className="offline-screen__hint">Проверьте соединение и обновите страницу</p>
            <Button type="primary" size="large" onClick={() => window.location.reload()}>
                Обновить
            </Button>
        </div>
    </ConfigProvider>
);

export default OfflineScreen;
